import { render, staticRenderFns } from "./PapelSignatarioNovo.vue?vue&type=template&id=d2e46866"
import script from "./PapelSignatarioNovo.vue?vue&type=script&lang=js"
export * from "./PapelSignatarioNovo.vue?vue&type=script&lang=js"
import style0 from "./PapelSignatarioNovo.vue?vue&type=style&index=0&id=d2e46866&prod&lang=stylus"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports